export class ClinicListItem {
  constructor({ id, name, tags, status = null, model }){
    this.id = id;
    this.name = name;
    this.tags = tags;
    this.status = status;
    this.model = model;
  }
}